
@if (!isStartingVir && !isCreatingCollaboration) {
  <div>
    <h3 class="medium" translate="">Create customer &amp; start VIR</h3>
    <p translate="">'VIR' is the real estate indexation tool that will index all buildings, mortgages and collaborations of a given person or company</p>
    <form [formGroup]="addressFormGroup">
      <unite-address-input-v2 class="mt2 flex flex-col" formGroupName="address" [disableManualEnter]="true">
      </unite-address-input-v2>
      @if (!retrievedOwners) {
        <div class="mt2">
          <unite-loading-button [disabled]="!isValidAddress" [loading]="isRetrievingOwners" [text]="'Retrieve owners' | translate" (click)="retrieveOwners()">
          </unite-loading-button>
          <em translate="">Cadastral charges will apply</em>
        </div>
      }
    </form>
    @if (retrievedOwners && owners.length > 0) {
      <div>
        <unite-user-autocomplete [label]="'Client adviser' | translate" required="" [control]="adviserFormControl"></unite-user-autocomplete>
        @if (owners.length > 1) {
          <hr>
            <div class="flex flex-row">
              <div class="basis-[70%]">
                <strong>
                  @for (owner of owners; track owner; let i = $index) {
                    <span>
                      {{ owner.name }}
                      @if (i < (owners.length - 1)) {
                        <span> &amp; </span>
                      }
                    </span>
                  }
                </strong><br>
                <mat-checkbox [checked]="true" [disabled]="true">
                  {{ 'Buildings' | translate }}
                </mat-checkbox>
              </div>
              <div class="flex flex-row justify-end content-center items-center h-full basis-[30%]">
                <button mat-raised-button="" (click)="processVirCollaborationByAddress()" color="primary">{{ 'Create customer &amp; start VIR' | translate }}</button>
              </div>
            </div>
          }
          <hr>
            @for (owner of owners; track owner) {
              <div class="mt1">
                <div class="basis-[70%]">
                  <div class="flex justify-start content-center items-center">
                    <strong>{{ owner.name }}</strong>
                    @if (owner.isEstimatingCosts) {
                      <span class="ml1"><mat-spinner diameter="16"></mat-spinner></span>
                    }
                    @if (!owner.isEstimatingCosts && owner.estimatedCosts) {
                      <span class="ml1"> ({{ owner.estimatedCosts.numberOfRegistrations }} {{ (owner.estimatedCosts.numberOfRegistrations === 1 ? 'cadastral registration' : 'cadastral registrations') | translate }})</span>
                    }
                  </div>
                  <mat-checkbox [checked]="true" [disabled]="true">
                    {{ 'Buildings' | translate }}
                  </mat-checkbox> <br>
                  <mat-checkbox [formControl]="owner.form.get('includeOwnership')">
                    {{ 'Collaborations / purchase information / groundlease' | translate }}
                    @if (owner.estimatedCosts) {
                      <span>({{ owner.estimatedCosts.ownerInformationCosts | currency:'EUR':'symbol':'1.0-0' }})</span>
                    }
                  </mat-checkbox> <br>
                  <mat-checkbox [formControl]="owner.form.get('includeMortgages')">
                    {{ 'Mortgages / seizures' | translate }}
                    @if (owner.estimatedCosts) {
                      <span>({{ owner.estimatedCosts.mortgageInformationCosts | currency:'EUR':'symbol':'1.0-0' }})</span>
                    }
                  </mat-checkbox> <br>
                  @if (owner.matches.length > 0) {
                    <div class="flex justify-start content-center items-center flex-row">
                      <mat-checkbox [formControl]="owner.form.get('isExistingCustomer')">{{ 'Is existing customer' | translate }}</mat-checkbox>
                      <mat-select [formControl]="owner.form.get('existingCustomerId')" class="ml1">
                        @for (match of owner.matches; track match) {
                          <mat-option [value]="match.customerId">{{ match.customerName }}</mat-option>
                        }
                      </mat-select>
                    </div>
                  }
                </div>
                <div class="flex justify-end content-center items-center flex-row basis-[30%]">
                  <button mat-raised-button="" color="primary" (click)="startVir(owner)">{{ 'Create customer &amp; start VIR' | translate }}</button>
                </div>
              </div>
            }
          </div>
        }
        @if (!isRetrievingOwners && retrievedOwners && owners.length === 0) {
          <div translate="">No owners found</div>
        }
      </div>
    }

    @if (isStartingVir || isCreatingCollaboration) {
      <div class="loader mt1">
        <mat-spinner diameter="32"></mat-spinner>
        @if (isStartingVir) {
          <span translate="">Starting VIR</span>
        }
        @if (isCreatingCollaboration) {
          <span translate="">Creating collaboration</span>
        }
      </div>
    }
